<template>
    <PdfViewer :ref="viewerKey" :saveDocumentChanges="saveDocumentChanges && editPermission" :isResizing="isResizing" @document-file-updated="updateDocumentFile" />
</template>

<script>
import DocumentService from '@/services/DocumentService';
import Utils from '@/ecm/common/Utils';
import PdfViewer from '@/components/document/PdfViewer';
import { EventBus } from '@/eventBus.js';

export default {
    name: 'DocumentViewer',
    components: {
        PdfViewer,
    },
    props: {
        saveDocumentChanges: {
            type: Boolean,
            default: false,
        },
        isResizing: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            viewerKey: 'documentListPdfViewer',
            documentId: 0,
            search: '',
            editPermission: false
        };
    },
    computed: {
        viewerInstance() {
            return this.$refs[this.viewerKey];
        },
    },
    methods: {
        loadDocument(documentId) {
            var self = this;
            DocumentService.canDisplay(documentId).then(async (canDisplay) => {
                let file = encodeURIComponent('/static/defaultDocument.pdf');

                if (canDisplay) {
                    const fileUrl = await DocumentService.display(documentId);
                    file = encodeURIComponent(fileUrl);
                }

                if (this.search) {
                    file += '&#search=' + encodeURIComponent(this.search);
                }

                self.viewerInstance.load(file, documentId);
            });
        },
        updateDocumentFile(newFile, documentId) {
            const uploadFileRequest = {
                ObjectID: documentId,
                NewFile: Array.from(newFile)
            };
            DocumentService.updateDocumentFile(uploadFileRequest)
                .then((res) => {
                    this.viewerInstance.setLoading(false);
                    if (res > 0) {
                        Utils.toast.success(this.$t('DocumentUpdatedSuccessfully'));
                        EventBus.$emit('refreshDocumentList', documentId);
                    }
                })
                .catch(() => {
                    this.viewerInstance.setLoading(false);
                });
        }
    },
    mounted() {
        EventBus.$on('loadDocument', (documentId, editPermission = false) => {
            if (documentId != this.documentId) {
                this.documentId = documentId;
                this.editPermission = editPermission;
                this.loadDocument(documentId);
            }
        });
        EventBus.$on('loadDocument-with-search', (documentId, search, editPermission = false) => {
            if (documentId != this.documentId) {
                this.documentId = documentId;
                this.editPermission = editPermission;
                this.search = search;
                this.loadDocument(documentId);
            }
        });
        EventBus.$on('cleanViewer', () => {
            const file = encodeURIComponent('/static/defaultDocument.pdf');
            this.viewerInstance.load(file);
        });
    },
    destroyed() {
        EventBus.$off('loadDocument');
        EventBus.$off('loadDocument-with-search');
        EventBus.$off('cleanViewer');
    },
};
</script>
